import { Firestore, storage } from './firebase';
export function convertCollectionsSnapshotToMap(snapshots) {
	return snapshots.docs.reduce((accumulator, collection) => {
		accumulator[collection.id] = collection.data();
		return accumulator;
	}, {});
}
export async function getNewDocRef(collectionName) {
	return await Firestore.collection(collectionName).doc();
}
export async function addDocument(collectionName, documentData) {
	return await Firestore.collection(collectionName)
		.add(documentData)
		.then((docRef) => docRef.id);
}
export async function setDocument(collectionName, docRef, documentData) {
	return await Firestore.collection(collectionName).doc(docRef).set(documentData);
}

export async function getDocuments(collectionName) {
	return await Firestore.collection(collectionName)
		.get()
		.then((querySnapshot) => querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
}
export async function getDocumentsByQuery(collectionName, query) {
	console.log(...query, collectionName, 'test');

	return await Firestore.collection(collectionName)
		.where(...query)
		.get()
		.then((querySnapshot) => querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
}

export async function deleteDocuments(collectionName) {
	const collectionRef = Firestore.collection(collectionName);
	var batch = Firestore.batch();
	await collectionRef
		.get()
		.then((querySnapshot) => querySnapshot.docs.map((doc) => batch.delete(collectionRef.doc(doc.id))));

	return await batch.commit().then(() => {
		console.log('Batch Deletion successfully committed!');
	});
}

export const addCollectionAndDocuments = async (collectionKey, objectsToAdd) => {
	const collectionRef = Firestore.collection(collectionKey);
	const batch = Firestore.batch();
	objectsToAdd.forEach((obj) => {
		const newDocRef = collectionRef.doc();
		batch.set(newDocRef, obj);
	});
	return await batch.commit().then(() => {
		console.log('Batch Addition successfully committed!');
	});
};

export const getDownloadURL = async (filePath) => {
	return await storage
		.ref()
		.child(filePath)
		.getDownloadURL()
		.then((url) => url)
		.catch((e) => e);
};
export const uploadFiles = async (filePath, file) => {
	let imageRef = storage.ref().child(filePath);
	await imageRef.put(file).catch((e) => e);
};
export const deleteFiles = async (filePath) => {
	let imageRef = storage.ref().child(filePath);
	await imageRef
		.delete()
		.then((success) => success)
		.catch((e) => e);
};
